import ReloadPageImage from "@shared/svg/reload-page.svg?react";
import { AlertBox } from "@shared/ui/AlertBox";
import React from "react";
import { useIntl } from "react-intl";
import { useGlobalAppVersionStore } from "~/stores/globalAppVersionStore";
import { useMaintenanceStore } from "~/stores/maintenanceStore";
import {
  Authenticate,
  useAuth,
  useBoxTokenRefresh,
  useChatTokenRefresh,
} from "~/components/general";
import SplashScreen from "~/components/general/SplashScreen";
import { FlashMessageWrapper } from "~/containers/_flashMessageWrapper";
import Layout from "~/layout";
import { useGetAppConfig } from "~/services/appConfig/_query";
import {
  useGetChatCredentials,
  useGetFoldersAccessToken,
} from "~/services/user/_query";
import "react-calendar/dist/Calendar.css";

const App = ({ match, location }) => {
  const { messages } = useIntl();
  const { chat, user } = useAuth();
  const { credentials, refetch } = useGetChatCredentials({ skip: !user });
  const { refetch: refetchBoxToken } = useGetFoldersAccessToken({
    skip: !user,
  });
  const flashMessage = useGlobalAppVersionStore();
  const { isMaintenanceOn } = useMaintenanceStore();
  const { loading: appConfigLoading, appConfig } = useGetAppConfig();

  useChatTokenRefresh({ chat, credentials, refetch });
  useBoxTokenRefresh(refetchBoxToken);

  if (isMaintenanceOn) {
    return (
      <AlertBox
        isOpen
        overlay
        image={<ReloadPageImage width="130" height="130" />}
        title={messages["common"]["maintenanceMessage"]}
      />
    );
  }

  if (appConfigLoading || !appConfig?.features?.length) {
    return <SplashScreen />;
  }

  return (
    <Authenticate>
      {flashMessage?.showFlashMessage && <FlashMessageWrapper />}
      <Layout match={match} location={location} />
    </Authenticate>
  );
};
export default App;
